import { usageTrackerMiddleware } from 'usage-tracker-redux';
import { getTracker } from './usageTracker';
export const trackerMiddleware = appNamespace => usageTrackerMiddleware(getTracker(appNamespace));